export enum VerificationProcessSteps {
  EmailVerificationStep = 'EmailVerificationStep',
  PhoneVerificationStep = 'PhoneVerificationStep',
  FailedVerificationStep = 'FailedVerificationStep',
}
